import type { BlogPost } from "./blog";

export const BLOG_BIRTHDAY_PART3: BlogPost[] = [
  {
    "slug": "korporativnyy-den-rozhdeniya-sotrudnika-spb",
    "title": "Корпоративный день рождения сотрудника в Петербурге: как отметить коллегу",
    "metaTitle": "Корпоративный день рождения сотрудника СПб | Паруса на крыше",
    "metaDescription": "Как отметить день рождения сотрудника в Санкт-Петербурге корпоративно. Ресторан с видом, скидка 20% именинникам. Ул. Марата 5.",
    "keywords": "корпоративный день рождения сотрудника спб, день рождения коллеги петербург, ресторан для коллег",
    "date": "2026-06-22",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "День рождения ключевого сотрудника — хороший повод показать, что компания ценит людей. Не корпоративная открытка, а настоящий ужин — это сигнал уважения, который работает лучше любого слова.",
    "sections": [
      {
        "heading": "Зачем отмечать день рождения сотрудника в ресторане",
        "body": "Корпоративная культура — это детали. Компания, которая организует сотруднику ужин на день рождения в «Парусах», говорит: «ты важен». Это создаёт лояльность лучше, чем любой бонус. Средний чек ~1 300 ₽/чел — небольшие инвестиции с хорошей отдачей в виде мотивации и удержания.",
        "list": [
          "Ужин для именинника и команды 5–15 человек",
          "Авторская кухня и панорамный вид",
          "Скидка 20% именинникам",
          "Средний чек ~1 300 ₽/чел"
        ]
      },
      {
        "heading": "Как организовать корпоративный день рождения",
        "body": "Лучший формат: небольшой ужин командой (5–12 человек), стол у окна с видом на Петербург. Руководитель делает тост. Именинник получает торт с поздравлением. Живая музыка создаёт атмосферу. Это занимает 2–2,5 часа и оставляет впечатление на долго.",
        "highlight": "Корпоративный день рождения в «Парусах» — это не «сходили поужинать». Это событие, о котором говорят в офисе на следующий день."
      },
      {
        "heading": "Практические детали",
        "body": "Бронируйте за 3–5 дней для небольшой команды. Скажите о дне рождения сотрудника при бронировании. Скидка 20% на счёт именинника. Безналичный расчёт — возможен, уточните при бронировании. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 3–5 дней",
          "Безналичный расчёт — по запросу",
          "Скидка 20% именинникам",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать корпоративный день рождения", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "romanticheskiy-den-rozhdeniya-para-spb",
    "title": "Романтический день рождения для пары в Петербурге",
    "metaTitle": "Романтический день рождения для пары в СПб | Паруса на крыше",
    "metaDescription": "Романтический день рождения вдвоём в Санкт-Петербурге: стол с видом, живая музыка, десерт в подарок. Скидка 20% именинникам.",
    "keywords": "романтический день рождения пара петербург, день рождения двоих ресторан спб, пара ужин день рождения",
    "date": "2026-06-22",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "День рождения вдвоём — это когда не нужна толпа. Нужно одно место, которое скажет всё без слов. Панорама Петербурга с 6-го этажа, живая музыка, правильное вино — и всё остальное сложится само.",
    "sections": [
      {
        "heading": "Романтический вечер: что делает его особенным",
        "body": "Романтический день рождения — это внимание к деталям. Стол у панорамного окна (лучший с видом на Казанский или закат). Свечи. Живая музыка — не фоновая, а та, которую слышишь. Шампанское на старт. Десерт с именем и датой. В «Парусах» это стандарт для особых вечеров. Скидка 20% именинникам.",
        "list": [
          "Стол у панорамного окна — по запросу",
          "Живая музыка — без доплаты",
          "Шампанское на старт",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Закат над Петербургом",
        "body": "Летом закат в Петербурге — в 22:00–23:00. Если бронируете на 20:00 — попадёте в золотой час. Свет, который падает на Казанский собор через панорамные окна «Парусов», — это то, что не воспроизвести никаким декором. Приходите в золотой час.",
        "highlight": "Закат над Петербургом в «Парусах» — один из самых романтичных видов в городе. Это работает на любую пару."
      },
      {
        "heading": "Как забронировать романтический стол",
        "body": "Позвоните: +7 (812) 991-10-90. Скажите «романтический ужин, день рождения, стол на двоих у окна». Попросите лучший вид. Уточните: нужны ли цветы (можно принести с собой). Скидка 20% именинникам.",
        "list": [
          "+7 (812) 991-10-90",
          "Скажите: стол на двоих у окна",
          "Цветы можно принести",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать романтический ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "den-rozhdeniya-dlya-vlyublennykh-spb",
    "title": "День рождения для влюблённых в Петербурге: двойное торжество",
    "metaTitle": "День рождения для влюблённых в СПб | Паруса на крыше",
    "metaDescription": "День рождения для влюблённой пары в Санкт-Петербурге: ужин с видом, живая музыка, особый вечер. Скидка 20% именинникам.",
    "keywords": "день рождения влюблённые петербург, праздник для пары спб, романтический праздник ресторан",
    "date": "2026-06-23",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Когда влюблённые отмечают день рождения вместе — это особый формат. Не просто ужин, а вечер, в котором каждый чувствует себя главным героем.",
    "sections": [
      {
        "heading": "День рождения вдвоём: особенная близость",
        "body": "Отмечать день рождения вдвоём — это выбор. Не нужны гости, не нужна суета. Нужны вы двое, красивое место и время, которое принадлежит только вам. «Паруса» для этого созданы: тихий стол у окна, вид на Петербург, живая музыка фоном.",
        "list": [
          "Тихий стол у окна на двоих",
          "Никакой суеты и лишних людей",
          "Живая музыка — мягкий фон",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Как сделать день рождения особенным для партнёра",
        "body": "Небольшие детали: цветы на столе (принесите заранее или закажите через флориста), бокал шампанского при входе (скажите об этом при бронировании), поздравление от ресторана (говорите о дне рождения). Это создаёт ощущение организованности и заботы.",
        "highlight": "Когда партнёр чувствует, что всё продумано заранее — это лучший подарок. Внимание к деталям важнее цены."
      },
      {
        "heading": "Бронирование",
        "body": "За 2–4 дня: +7 (812) 991-10-90. Стол на двоих у окна. День рождения — сообщите. Скидка 20% именинникам.",
        "list": [
          "За 2–4 дня",
          "+7 (812) 991-10-90",
          "Стол на двоих у окна",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать особый вечер", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "den-rozhdeniya-s-vidom-na-neva-spb",
    "title": "День рождения с видом на Неву в Петербурге: где найти лучший столик",
    "metaTitle": "День рождения с видом на Неву в СПб | Паруса на крыше",
    "metaDescription": "Где отметить день рождения с видом на Неву в Санкт-Петербурге. Панорамный вид с 6-го этажа, живая музыка, скидка 20% именинникам.",
    "keywords": "день рождения вид на Неву петербург, ресторан панорама Нева спб, праздник вид вода",
    "date": "2026-06-23",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Вид на Неву — мечта многих гостей Петербурга. Широкая река, разводные мосты, корабли. Но найти ресторан с действительно впечатляющим видом — задача не простая. Разбираем варианты.",
    "sections": [
      {
        "heading": "Вид на Петербург: что важнее — вода или панорама",
        "body": "Ресторанов с прямым видом на Неву немного, и большинство из них — гостиничные рестораны с ограниченным выбором. «Паруса на крыше» предлагают другое: не прямой вид на воду, а панорама исторического центра — Казанский собор, купола, крыши, и в ясную погоду — дальние виды до Финского залива. Это более богатая картина, чем просто «вот река».",
        "list": [
          "Панорама 300° на исторический центр",
          "Казанский собор и купола — в прямом обзоре",
          "В ясную погоду — виды на горизонт",
          "6-й этаж Olympic Plaza"
        ]
      },
      {
        "heading": "Почему панорама лучше, чем «вид на Неву»",
        "body": "Реальный вид на Неву с ресторана — это обычно узкая полоска воды через стекло. Панорамный вид с 6-го этажа на центр Петербурга — это объём, горизонт, несколько ориентиров. Это то, что хочется фотографировать. Для дня рождения — именно это важно.",
        "highlight": "С 6-го этажа «Парусов» видно больше Петербурга, чем с большинства набережных. Это не набережная — это выше."
      },
      {
        "heading": "Бронирование",
        "body": "Для стола с лучшим видом — бронируйте у окна заранее. +7 (812) 991-10-90. Скидка 20% именинникам.",
        "list": [
          "Просите стол у окна",
          "Бронируйте заранее",
          "Скидка 20% именинникам",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать стол с видом", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-panoramnyy-vid-peterburg",
    "title": "День рождения с панорамным видом на Петербург: лучшие места",
    "metaTitle": "День рождения с панорамным видом на Петербург | Паруса",
    "metaDescription": "Где отметить день рождения с панорамным видом в Санкт-Петербурге. «Паруса на крыше» — 6-й этаж, 300° на город. Скидка 20% именинникам.",
    "keywords": "день рождения панорамный вид петербург, праздник с видом спб, ресторан панорама день рождения",
    "date": "2026-06-23",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_clouds.webp",
    "lead": "Панорамный вид на Петербург — лучшая декорация для любого праздника. Не нужно ни воздушных шаров, ни специального оформления. Нужен только правильный этаж.",
    "sections": [
      {
        "heading": "Что такое настоящий панорамный вид",
        "body": "Настоящий панорамный вид — это когда вы видите горизонт, несколько ориентиров и пространство над крышами. Не «окошко на улицу», а картина. «Паруса на крыше» на 6-м этаже Olympic Plaza дают именно это: 300° обзор на исторический центр. Казанский собор, Никольский собор, купола разных церквей, крыши — слой за слоем. Это живопись, которая меняется с каждым часом.",
        "list": [
          "300° обзор на центр Петербурга",
          "Казанский и Никольский соборы — прямо перед вами",
          "Вид меняется: день, закат, ночь",
          "6-й этаж Olympic Plaza"
        ]
      },
      {
        "heading": "Панорама как главный элемент праздника",
        "body": "Когда гости входят и видят Петербург с 6-го этажа — это момент. Не нужно ничего объяснять, никакого декора, никаких «ах и ох». Место говорит само. Именно поэтому «Паруса» выбирают для дней рождения, которые должны запомниться. Скидка 20% именинникам — как дополнение к главному.",
        "highlight": "Панорама — не фон для праздника. Панорама — это и есть праздник. Остальное — еда, музыка, люди — усиливает впечатление."
      },
      {
        "heading": "Как забронировать лучший стол",
        "body": "Лучшие столы с видом бронируются заранее. Позвоните за 3–7 дней: +7 (812) 991-10-90. Скажите «стол с лучшим видом на день рождения». Скидка 20% именинникам.",
        "list": [
          "Бронируйте за 3–7 дней",
          "Просите лучший вид",
          "Скидка 20% именинникам",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать стол с панорамой", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-na-vysote-peterburg",
    "title": "День рождения на высоте в Петербурге: над крышами города",
    "metaTitle": "День рождения на высоте в Петербурге | Паруса на крыше",
    "metaDescription": "Отметить день рождения на высоте в Санкт-Петербурге: ресторан на 6-м этаже с видом на крыши. Скидка 20% именинникам. Живая музыка.",
    "keywords": "день рождения на высоте петербург, ресторан на этаже спб, праздник над городом петербург",
    "date": "2026-06-23",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_summer.webp",
    "lead": "Петербург с высоты — это совсем другой город. Крыши, купола, дымоходы, которые поднимаются над суетой. День рождения над городом — это то, о чём говорят потом.",
    "sections": [
      {
        "heading": "Почему «на высоте» — это особенно",
        "body": "Большинство людей знает Петербург снизу: фасады, улицы, мосты. С 6-го этажа «Парусов» видно город с другой стороны: крыши, купола, горизонт. Это другой Петербург. И день рождения здесь — другой опыт. Для гостей, которые живут в городе всю жизнь, это открытие. Для туристов — откровение.",
        "list": [
          "6-й этаж — выше большинства зданий центра",
          "Виды на крыши и купола",
          "Другой Петербург — сверху",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "День рождения над городом: что нужно",
        "body": "Стол у окна. Хорошее вино. Живая музыка (с четверга по воскресенье). Именной торт. Рядом — люди, которые важны. Этого достаточно, когда за окном Петербург.",
        "highlight": "Когда за окном Петербург с высоты — дополнительного декора не нужно. Природный вид работает лучше любых шаров и гирлянд."
      },
      {
        "heading": "Бронирование",
        "body": "За 2–5 дней: +7 (812) 991-10-90. Стол у окна — по запросу. Скидка 20% именинникам.",
        "list": [
          "За 2–5 дней",
          "Стол у окна",
          "+7 (812) 991-10-90",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать день рождения на высоте", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-s-muzykoy-peterburg",
    "title": "День рождения с живой музыкой в Петербурге: как найти правильное место",
    "metaTitle": "День рождения с живой музыкой в Петербурге | Паруса на крыше",
    "metaDescription": "Где отметить день рождения с живой музыкой в Санкт-Петербурге. «Паруса на крыше» — живая музыка чт-вс. Скидка 20% именинникам.",
    "keywords": "день рождения живая музыка петербург, ресторан живая музыка день рождения спб, праздник под музыку",
    "date": "2026-06-23",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Живая музыка на день рождения — это то, что нельзя воспроизвести плейлистом. Живой голос или инструмент в нужный момент создаёт атмосферу, которую запоминают. Разбираем, где в Петербурге это есть.",
    "sections": [
      {
        "heading": "Живая музыка: почему это важно",
        "body": "Живая музыка создаёт ощущение события. Когда именинник входит в зал, а музыкант играет — это уже не обычный ужин. Когда торт несут под живую мелодию — это момент. «Паруса на крыше» — ресторан с живой музыкой с четверга по воскресенье включительно. Дополнительных расходов на музыку нет — она часть вечера.",
        "list": [
          "Живая музыка: чт–вс — без доплаты",
          "Разные жанры: джаз, эстрада, акустика",
          "Вынос торта под музыку — по запросу",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Как музыка усиливает праздник",
        "body": "Правильная музыка делает три вещи: создаёт атмосферу при входе, заполняет паузы в разговоре и превращает «вынос торта» в момент. В «Парусах» музыканты знают, когда играть тихо, а когда усилить — это опыт, наработанный за годы. Вы можете заранее попросить конкретную мелодию для поздравления.",
        "highlight": "Попросите музыкантов сыграть любимую мелодию именинника в момент выноса торта. Это занимает 30 секунд — и остаётся в памяти навсегда."
      },
      {
        "heading": "Когда лучше приходить",
        "body": "Живая музыка обычно начинается в 19:00–20:00. Бронируйте ужин на 19:30–20:00, чтобы успеть к музыке. Чт–вс — обязательно. Уточняйте расписание при бронировании. +7 (812) 991-10-90.",
        "list": [
          "Музыка с 19:00–20:00",
          "Бронируйте ужин на 19:30",
          "Чт–вс — живая музыка",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать праздник с живой музыкой", "href": "/zhivaya-muzyka" }
  },
  {
    "slug": "dzhaz-den-rozhdeniya-restoran-spb",
    "title": "День рождения под джаз в Петербурге: атмосфера и место",
    "metaTitle": "День рождения под джаз в Петербурге | Паруса на крыше",
    "metaDescription": "Отметить день рождения под джаз в Санкт-Петербурге: ресторан с живым джазом, панорама, авторская кухня. Скидка 20% именинникам.",
    "keywords": "день рождения джаз петербург, джаз ресторан день рождения спб, живая музыка джаз праздник",
    "date": "2026-06-23",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "День рождения под живой джаз — это определённый стиль жизни. Не громко, не пошло — умно и красиво. Петербург создан для такого формата.",
    "sections": [
      {
        "heading": "Джаз и день рождения",
        "body": "Джаз на дне рождения создаёт особую атмосферу: взрослую, уютную, без лишней суеты. Это не попса и не техно — это музыка, под которую хочется разговаривать и слушать. В «Парусах на крыше» живая музыка — частая составляющая вечеров с четверга по воскресенье. Жанр — зависит от вечера, уточните при бронировании.",
        "list": [
          "Живая музыка чт–вс",
          "Джаз — уточняйте при бронировании",
          "Правильная акустика для живого звука",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Атмосфера джазового вечера",
        "body": "Панорама Петербурга + джаз + авторская кухня = одно из лучших сочетаний в городе. Это Нью-Йорк и Петербург одновременно. Именно за эту атмосферу «Паруса» ценят люди с вкусом. Рейтинг 5,0, 2 606+ отзывов — это в том числе за джазовые вечера.",
        "highlight": "Джаз под вид на Казанский собор — это то, что отличает петербургскую гастрономическую культуру от всего остального."
      },
      {
        "heading": "Как организовать",
        "body": "Бронируйте на четверг–воскресенье. Уточните жанр музыки при бронировании. Стол у окна для самого красивого вечера. +7 (812) 991-10-90.",
        "list": [
          "Чт–вс: живая музыка",
          "Уточните жанр при бронировании",
          "Стол у окна",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать джазовый вечер", "href": "/zhivaya-muzyka" }
  },
  {
    "slug": "den-rozhdeniya-v-tsentre-peterburga-gde",
    "title": "День рождения в центре Петербурга: лучшие места и советы",
    "metaTitle": "День рождения в центре Петербурга — где | Паруса на крыше",
    "metaDescription": "Где отметить день рождения в центре Санкт-Петербурга. Рестораны в Центральном районе с атмосферой. Скидка 20% именинникам. Ул. Марата 5.",
    "keywords": "день рождения центр петербурга, ресторан день рождения центральный район спб, праздник центр города",
    "date": "2026-06-24",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Центр Петербурга — лучшее место для праздника. Исторические фасады, парадные набережные, рестораны с историей. Но выбрать среди всего этого правильное место — вопрос.",
    "sections": [
      {
        "heading": "Почему центр Петербурга — для особых вечеров",
        "body": "Центральный район Петербурга — это сердце города. Невский проспект, Казанский собор, Марсово поле, улица Рубинштейна, Марата — всё рядом. Прогулка до и после ужина — часть вечера. «Паруса на крыше» на ул. Марата, 5 — в самом сердце этого всего. До Казанского собора пешком 10 минут. До Невского — 5 минут.",
        "list": [
          "Ул. Марата, 5 — центр Петербурга",
          "5 минут до Невского пешком",
          "10 минут до Казанского собора",
          "Парковка в Olympic Plaza"
        ]
      },
      {
        "heading": "Что делает центральный ресторан особенным",
        "body": "Ресторан в центре Петербурга — это возможность совместить ужин с прогулкой. Пришли пешком через Невский, поужинали, вышли на Марата и дошли до набережной Фонтанки. Это петербургский формат вечера — и «Паруса» в нём занимают центральное место.",
        "highlight": "Адрес «Парусов» — ул. Марата, 5, 6-й этаж Olympic Plaza. Это середина центра Петербурга. Добраться сюда удобно с любой точки города."
      },
      {
        "heading": "Транспорт и логистика",
        "body": "Метро: Маяковская — 5 мин пешком. Достоевская — 10 мин. Парковка: в Olympic Plaza. Такси: высаживайте у входа в комплекс, ул. Марата, 5. Скидка 20% именинникам. +7 (812) 991-10-90.",
        "list": [
          "Метро Маяковская — 5 мин пешком",
          "Парковка в Olympic Plaza",
          "Такси: ул. Марата, 5",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать в центре города", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-ulitsa-marata-restoran",
    "title": "День рождения на улице Марата в Петербурге: ресторанная улица",
    "metaTitle": "День рождения на ул. Марата в Петербурге | Паруса на крыше",
    "metaDescription": "Лучший ресторан на улице Марата для дня рождения в Санкт-Петербурге. «Паруса на крыше» — 6-й этаж, вид на город. Скидка 20% именинникам.",
    "keywords": "ресторан улица марата день рождения петербург, марата 5 ресторан праздник, где отметить марата спб",
    "date": "2026-06-24",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Улица Марата — одна из главных ресторанных улиц Петербурга. Разнообразие заведений, нетуристическая атмосфера, шаговая доступность от центра. «Паруса на крыше» — на её вершине в буквальном смысле: 6-й этаж, Olympic Plaza.",
    "sections": [
      {
        "heading": "Ул. Марата как гастрономический квартал",
        "body": "От метро Маяковская до Загородного проспекта — это полтора километра ресторанов, кафе и баров. Здесь можно найти всё: от уличной еды до авторских ресторанов. Но выше всех — «Паруса на крыше» в Olympic Plaza: панорамный вид на весь центр города, которого нет ни у одного из соседей по улице.",
        "list": [
          "Olympic Plaza, 6-й этаж, ул. Марата 5",
          "Единственный ресторан с видом на ул. Марата",
          "Рядом: Маяковская, Достоевская",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Почему выбирают именно «Паруса»",
        "body": "На улице Марата много хороших мест. Но вид с 6-го этажа есть только в «Парусах». Живая музыка есть только в «Парусах». Рейтинг 5,0 на Яндексе с 2 606+ отзывами — только в «Парусах» среди всех ресторанов на Марата. Для особого вечера — выбор очевиден.",
        "highlight": "«Паруса» работают с 2009 года. На улице Марата много появилось и закрылось за это время. «Паруса» остаются первым."
      },
      {
        "heading": "Бронирование",
        "body": "+7 (812) 991-10-90. Ул. Марата, 5, 6-й этаж. Скидка 20% именинникам.",
        "list": [
          "+7 (812) 991-10-90",
          "Ул. Марата, 5, Olympic Plaza",
          "6-й этаж, лифт внутри",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать на ул. Марата", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-na-kryshe-ideya",
    "title": "День рождения на крыше в Петербурге: идеи и лучшие места",
    "metaTitle": "День рождения на крыше в Петербурге — идеи | Паруса",
    "metaDescription": "Идеи для дня рождения на крыше в Санкт-Петербурге. «Паруса на крыше» — ресторан с видом и терраса. Скидка 20% именинникам.",
    "keywords": "день рождения на крыше петербург, праздник на крыше спб, крыша ресторан день рождения",
    "date": "2026-06-24",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/terrace.webp",
    "lead": "День рождения на крыше — мечта многих петербуржцев. Это образ: закат, весь город перед вами, бокал в руке. «Паруса на крыше» воплощают эту мечту — с одним уточнением: это не открытая крыша, а ресторан с панорамными окнами и собственной верандой.",
    "sections": [
      {
        "heading": "Что значит «на крыше» в Петербурге",
        "body": "Прогулки по реальным крышам Петербурга — романтичная традиция, но нелегальная. Ресторан «на крыше» — это ресторан, который создаёт ощущение высоты. «Паруса» — на 6-м этаже Olympic Plaza, с панорамными окнами. Летом открыта терраса — ближайшее к «настоящей крыше» легальное место в центре города.",
        "list": [
          "6-й этаж: ощущение высоты",
          "Летняя терраса — настоящий открытый воздух",
          "Панорамные окна — вид круглый год",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Терраса летом",
        "body": "Летняя терраса «Парусов» открыта с мая по сентябрь (по погоде). Это та самая «крыша»: открытый воздух, вид на Петербург, живая музыка, тёплый вечер. День рождения на террасе летом — это пиковый опыт. Белые ночи в июне-июле добавляют магии.",
        "highlight": "Терраса «Парусов» — это 6-й этаж + открытый воздух + Петербург в белую ночь. Это лучший столик в городе для летнего дня рождения."
      },
      {
        "heading": "Зимой: панорама вместо крыши",
        "body": "Зимой терраса закрыта, но панорамные окна дают тот же вид — только в тепле. Ночной Петербург с 6-го этажа в декабре с огнями гирлянд — ничуть не хуже летней картины. Скидка 20% именинникам круглый год. +7 (812) 991-10-90.",
        "list": [
          "Лето: терраса открытая",
          "Зима: панорамные окна с тем же видом",
          "Круглый год: скидка 20% именинникам",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать на террасе", "href": "/terrasa" }
  },
  {
    "slug": "krysha-peterburg-prazdnik-vzroslyy",
    "title": "Взрослый праздник на крыше Петербурга: стиль и атмосфера",
    "metaTitle": "Взрослый праздник на крыше Петербурга | Паруса на крыше",
    "metaDescription": "Взрослый день рождения на крыше в Санкт-Петербурге: стильный ресторан с видом, авторская кухня. Скидка 20% именинникам.",
    "keywords": "взрослый праздник крыша петербург, стильный день рождения спб, день рождения крыша взрослых",
    "date": "2026-06-24",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_sunset.webp",
    "lead": "Взрослый день рождения — это когда хочется стиля, а не суеты. Место, которое говорит о вас. Петербург с высоты — именно такая декларация.",
    "sections": [
      {
        "heading": "Стиль без показухи",
        "body": "Взрослый праздник — это не «дорого». Это «правильно выбрано». Нет смысла тратить деньги на декор из шаров, если за окном Петербург с 6-го этажа. Нет смысла нанимать ведущего, если живая музыка создаёт атмосферу сама. «Паруса на крыше» — ресторан, в котором правильно выбрано всё.",
        "list": [
          "Панорама вместо декора",
          "Живая музыка вместо ведущего",
          "Авторская кухня вместо кейтеринга",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Кто выбирает «Паруса» для взрослого праздника",
        "body": "Люди, которые ценят качество над количеством. Те, кто был в разных ресторанах и понял, что важна атмосфера, а не размер. Гости «Парусов» — люди с вкусом. Рейтинг 5,0 — это их оценка.",
        "highlight": "Взрослый праздник в «Парусах» — это когда гости говорят «хорошее место» не потому что так принято, а потому что это правда."
      },
      {
        "heading": "Бронирование",
        "body": "+7 (812) 991-10-90. За 3–7 дней. Стол у окна — по запросу.",
        "list": [
          "За 3–7 дней",
          "+7 (812) 991-10-90",
          "Стол у окна",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать взрослый праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-s-banketom-spb",
    "title": "День рождения с банкетом в Петербурге: организация и стоимость",
    "metaTitle": "День рождения с банкетом в Петербурге | Паруса на крыше",
    "metaDescription": "Организация банкета на день рождения в Санкт-Петербурге. Банкетный зал с видом, меню от 2500 ₽/чел. Скидка 20% именинникам.",
    "keywords": "день рождения с банкетом петербург, банкет день рождения спб, организация банкета петербург",
    "date": "2026-06-24",
    "category": "День рождения в Петербурге",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Банкет на день рождения — это серьёзное мероприятие. Нужен правильный зал, выверенное меню и команда, которая не подведёт. Разбираем, как организовать банкет в Петербурге правильно.",
    "sections": [
      {
        "heading": "Банкет на день рождения: что входит",
        "body": "Стандартный банкет включает: аперитив при встрече гостей, холодные закуски на стол, горячие закуски, основное блюдо с гарниром, десерт, торт именинника. Безалкогольные напитки — обычно включены. Алкоголь — по карте или пакетом. В «Парусах» банкетное меню от 2 500 ₽/чел — это полноценный праздничный ужин.",
        "list": [
          "Аперитив + холодные закуски",
          "Горячее с гарниром",
          "Десерт + торт именинника",
          "Банкетное меню от 2 500 ₽/чел"
        ]
      },
      {
        "heading": "Как выбрать зал для банкета",
        "body": "Выбирайте зал по размеру гостей: для 20–40 человек — один формат, для 50–100 — другой, для 100+ — большой зал. В «Парусах» несколько залов разного размера, все с видом на Петербург. Банкетный менеджер помогает с выбором. Вместимость — до 300 гостей.",
        "highlight": "Банкетный менеджер «Парусов» ведёт вас от первого звонка до финала вечера. Вы только приходите и празднуете. Остальное — наша работа."
      },
      {
        "heading": "Бюджет банкета",
        "body": "Банкет на 30 гостей: от 75 000 ₽ (2 500 × 30). Банкет на 50 гостей: от 125 000 ₽. Банкет на 100 гостей: от 250 000 ₽. Алкоголь — дополнительно. Ведущий — по запросу. Торт — под заказ. Бронируйте за 2–6 недель в зависимости от размера. +7 (812) 991-10-90.",
        "list": [
          "30 гостей: от 75 000 ₽",
          "50 гостей: от 125 000 ₽",
          "100 гостей: от 250 000 ₽",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Обсудить банкет на день рождения", "href": "/banket" }
  },
  {
    "slug": "banket-ili-uzhin-den-rozhdeniya-chto-vybrat",
    "title": "Банкет или ужин на день рождения: что выбрать и как решить",
    "metaTitle": "Банкет или ужин на день рождения — что выбрать | Паруса",
    "metaDescription": "Как выбрать между банкетом и ужином à la carte на день рождения в Петербурге. Плюсы и минусы каждого формата. Скидка 20% именинникам.",
    "keywords": "банкет или ужин день рождения петербург, формат праздника ресторан спб, как выбрать банкет",
    "date": "2026-06-24",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Банкет или à la carte? Этот вопрос задают почти все, кто планирует день рождения в ресторане. Разбираем честно: что подходит для какого случая.",
    "sections": [
      {
        "heading": "Банкет: плюсы и минусы",
        "body": "Плюсы банкета: фиксированная стоимость (легко рассчитать бюджет), еда приходит одновременно для всех (никто не ждёт), официанты не отвлекают от праздника, можно сосредоточиться на программе. Минусы: менее гибко (не все блюда можно заменить), нужен минимальный заказ на человека, требует планирования. Лучше для: 20+ гостей, юбилеи, торжественные события.",
        "list": [
          "Фиксированная стоимость",
          "Еда одновременно для всех",
          "Лучше для 20+ гостей",
          "Требует планирования"
        ]
      },
      {
        "heading": "Ужин à la carte: плюсы и минусы",
        "body": "Плюсы à la carte: каждый выбирает сам (максимальная гибкость), нет минимального заказа, подходит для небольших компаний. Минусы: сложнее координировать подачу для большой группы, итоговый счёт сложнее рассчитать заранее. Лучше для: 2–15 гостей, камерный вечер, когда у всех разные предпочтения.",
        "highlight": "Правило: до 15 человек — à la carte. От 20 человек — банкет. Это практика большинства ресторанов и самый логичный подход."
      },
      {
        "heading": "Что предлагают «Паруса»",
        "body": "Оба формата доступны в «Парусах». Банкетное меню от 2 500 ₽/чел — для больших компаний. À la carte (средний чек ~1 300 ₽/чел) — для камерного вечера. Скидка 20% именинникам — в обоих форматах. +7 (812) 991-10-90.",
        "list": [
          "Банкет от 2 500 ₽/чел (20+ гостей)",
          "À la carte: ~1 300 ₽/чел (до 15 гостей)",
          "Скидка 20% в обоих форматах",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Обсудить формат вечера", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-bez-banketnogo-zala-spb",
    "title": "День рождения без банкетного зала в Петербурге: альтернативы",
    "metaTitle": "День рождения без банкетного зала в СПб | Паруса на крыше",
    "metaDescription": "Как отметить день рождения в Петербурге без аренды зала: стол у окна, à la carte, живая музыка. Скидка 20% именинникам.",
    "keywords": "день рождения без зала петербург, день рождения без банкета спб, праздник без аренды зала",
    "date": "2026-06-25",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Не всегда нужен банкетный зал. Иногда лучший день рождения — несколько столов в общем зале ресторана с видом на Петербург. Без помпы, без аренды — просто хорошее место.",
    "sections": [
      {
        "heading": "Когда зал не нужен",
        "body": "Для компании до 15 человек зал чаще всего избыточен. Стол у панорамных окон в «Парусах» — это уже «особое место». Никакой аренды, никаких минимальных заказов по завышенным ценам. Просто забронируйте стол у окна, укажите день рождения — и приходите.",
        "list": [
          "До 15 человек: стол в общем зале",
          "Нет аренды зала — нет доплаты",
          "Стол у окна — по запросу",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Что даёт общий зал",
        "body": "В общем зале «Парусов» есть всё то же самое, что в отдельном: панорамный вид, живая музыка, авторская кухня, внимательный сервис. Единственное отличие — нет приватности. Для большинства дней рождения до 15 человек это не проблема.",
        "highlight": "Камерный день рождения в «Парусах» без аренды зала — это иногда лучше, чем с арендой. Атмосфера общего ресторана добавляет живости."
      },
      {
        "heading": "Когда всё же нужен зал",
        "body": "Если гостей больше 20, если нужна программа с ведущим, если хотите музыку конкретного жанра в определённое время — нужен зал. Для 15–20 и меньше — стол в зале работает отлично. Уточните у менеджера. +7 (812) 991-10-90.",
        "list": [
          "До 15: стол в общем зале",
          "15–20: граница, уточните",
          "20+: лучше отдельный зал",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать стол (без зала)", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-s-deputom-chto-eto",
    "title": "День рождения с депозитом в ресторане: что это и как работает",
    "metaTitle": "День рождения с депозитом в ресторане | Паруса на крыше",
    "metaDescription": "Что такое депозит при бронировании стола на день рождения. Как это работает в «Парусах на крыше». Скидка 20% именинникам.",
    "keywords": "депозит день рождения ресторан, что такое депозит ресторан петербург, бронирование с депозитом",
    "date": "2026-06-25",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "«Депозит при бронировании» — фраза, которая останавливает многих. Что это значит, зачем он нужен и как это работает на практике?",
    "sections": [
      {
        "heading": "Что такое депозит в ресторане",
        "body": "Депозит — это предоплата, которая засчитывается в счёт вашего заказа. Если вы внесли 5 000 ₽ депозита, на эту сумму уменьшается финальный счёт. Депозит не сгорает — он либо полностью учитывается в счёте, либо возвращается при отмене за установленный срок. Это защита ресторана от no-show (когда гости не приходят после бронирования).",
        "list": [
          "Депозит = предоплата, которая идёт в счёт",
          "Не сгорает — учитывается или возвращается",
          "Защита ресторана от no-show",
          "Обычно требуется для выходных и больших компаний"
        ]
      },
      {
        "heading": "Как это работает в «Парусах»",
        "body": "При бронировании выходных или праздничных дней для больших компаний может потребоваться депозит. Уточните условия при звонке. Депозит подтверждает бронирование — вам гарантированно выделяют зал или стол. Это взаимная уверенность.",
        "highlight": "Депозит — не «деньги на ветер». Это бронирование, которое работает в обе стороны: вы уверены, что стол будет, ресторан уверен, что вы придёте."
      },
      {
        "heading": "Как уточнить условия",
        "body": "Позвоните: +7 (812) 991-10-90. Спросите о депозите для вашей даты и компании. Условия отмены — уточните при бронировании.",
        "list": [
          "+7 (812) 991-10-90",
          "Спросите о депозите для вашей даты",
          "Условия отмены — уточните",
          "Депозит идёт в счёт финального заказа"
        ]
      }
    ],
    "cta": { "text": "Уточнить условия бронирования", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-s-detmi-restoran-spb",
    "title": "День рождения с детьми в ресторане Петербурга: семейный формат",
    "metaTitle": "День рождения с детьми в ресторане СПб | Паруса на крыше",
    "metaDescription": "День рождения с детьми в ресторане Санкт-Петербурга. Детское меню, комфортные условия, живая музыка. Скидка 20% именинникам.",
    "keywords": "день рождения с детьми ресторан петербург, праздник дети взрослые спб, семья ресторан день рождения",
    "date": "2026-06-25",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "День рождения взрослого, на который приглашены дети — это особая задача. Нужно, чтобы хорошо было и взрослым, и детям. Разбираем, как это организовать в Петербурге.",
    "sections": [
      {
        "heading": "Как угодить и взрослым, и детям",
        "body": "Основное правило: взрослые хотят атмосферу, дети хотят торт и побегать. Ресторан должен даёт атмосферу взрослым и не мешать детям. «Паруса» подходят: комфортные залы, детское меню, нет запретов на детей. При бронировании скажите о детях — поможем с рассадкой.",
        "list": [
          "Детское меню — доступно",
          "Просите рассадку с учётом детей",
          "Детские стульчики по запросу",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Практические советы",
        "body": "Ранний вечер (17:00–18:00) лучше, чем поздний — дети не устали. Если детей несколько — попросите место у края зала, чтобы можно было выходить без суеты. Торт ребёнкам нравится больше, чем взрослым — сделайте момент выноса торта ярким.",
        "highlight": "Вынос торта в «Парусах» с живой музыкой производит впечатление на детей не меньше, чем на взрослых. Это момент, который объединяет."
      },
      {
        "heading": "Как организовать",
        "body": "Бронируйте за 1–2 недели. Скажите о детях. Ранний вечер: 17:00–18:00. +7 (812) 991-10-90.",
        "list": [
          "За 1–2 недели",
          "Скажите о количестве детей",
          "17:00–18:00 — лучшее время",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать с детьми", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-v-budni-restoran-spb",
    "title": "День рождения в будни в ресторане Петербурга: преимущества",
    "metaTitle": "День рождения в будни в ресторане СПб | Паруса на крыше",
    "metaDescription": "Преимущества дня рождения в будни в Санкт-Петербурге: лучшие столики, внимание персонала. Бизнес-ланч от 590 ₽. Скидка 20% именинникам.",
    "keywords": "день рождения в будни ресторан петербург, праздник в рабочий день спб, будний день рождения",
    "date": "2026-06-25",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "День рождения в будни — неочевидный, но хороший выбор. Тише, внимательнее, дешевле. Особенно если вы не любите суету выходного дня.",
    "sections": [
      {
        "heading": "Почему будний день рождения — хорошая идея",
        "body": "В будни рестораны спокойнее. Лучшие столики у окна — свободны. Персонал уделяет больше внимания. Никакой конкуренции за место с другими компаниями. Если именинник работает — договоритесь отметить в обед (бизнес-ланч от 590 ₽ с видом на Петербург) или сразу после работы (18:00–19:00).",
        "list": [
          "Лучшие столики доступнее",
          "Больше внимания от персонала",
          "Бизнес-ланч от 590 ₽ в обед",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Будние праздники: форматы",
        "body": "Обед в честь дня рождения: бизнес-ланч для небольшой компании (5–10 человек) в 12:00–16:00. Ужин после работы: 18:00–20:00, живая музыки — по расписанию (уточните). Для будней бронируйте за 1–2 дня — этого обычно достаточно.",
        "highlight": "Бизнес-ланч на день рождения от 590 ₽ с видом на Петербург — лучшее соотношение впечатления и цены в городе."
      },
      {
        "heading": "Как организовать",
        "body": "За 1–2 дня: +7 (812) 991-10-90. Скажите о дне рождения. Скидка 20% именинникам — в будни тоже.",
        "list": [
          "За 1–2 дня",
          "+7 (812) 991-10-90",
          "Скидка 20% в будни тоже",
          "Бизнес-ланч от 590 ₽ в 12:00–16:00"
        ]
      }
    ],
    "cta": { "text": "Забронировать будний праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "spontannyy-prazdnik-dr-restoran-spb",
    "title": "Спонтанный день рождения в ресторане Петербурга: сегодня или завтра",
    "metaTitle": "Спонтанный день рождения в ресторане СПб | Паруса",
    "metaDescription": "Как организовать день рождения в последний момент в Санкт-Петербурге. Бронирование за день. Скидка 20% именинникам. Ул. Марата 5.",
    "keywords": "спонтанный день рождения ресторан петербург, день рождения в последний момент спб, срочное бронирование",
    "date": "2026-06-25",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "«Ой, у меня завтра день рождения, и я ничего не организовал(а)». Знакомо? Спонтанный праздник — это не проблема, если знаешь, куда звонить.",
    "sections": [
      {
        "heading": "Как организовать за 24 часа",
        "body": "Позвоните сегодня: +7 (812) 991-10-90. В будни бронирование за день — обычная практика. В выходные — зависит от загрузки, но часто тоже возможно. Скажите о дне рождения — кухня подготовит десерт. Никаких дополнительных условий не нужно для камерного вечера.",
        "list": [
          "+7 (812) 991-10-90 — звоните прямо сейчас",
          "Будни: бронирование за день — норма",
          "Выходные: зависит от загрузки",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Что можно сделать за 24 часа",
        "body": "За 24 часа реально: забронировать стол, договориться о десерте, пригласить 5–10 гостей. Торт под заказ за 24 часа — возможен, уточните при звонке. Цветы — купить по дороге. Этого более чем достаточно для хорошего вечера. Место сделает остальное.",
        "highlight": "Спонтанный день рождения в «Парусах» — это иногда лучше запланированного. Никакой суеты заготовок. Просто пришли и всё случилось."
      },
      {
        "heading": "Контакты",
        "body": "+7 (812) 991-10-90. Ул. Марата, 5, Olympic Plaza, 6-й этаж.",
        "list": [
          "+7 (812) 991-10-90",
          "Ул. Марата, 5, 6-й этаж",
          "Скидка 20% именинникам",
          "Будни и выходные"
        ]
      }
    ],
    "cta": { "text": "Позвонить и забронировать", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-obed-ili-uzhin-spb",
    "title": "День рождения в обед или ужин: что лучше для праздника",
    "metaTitle": "День рождения в обед или ужин в СПб | Паруса на крыше",
    "metaDescription": "Что лучше для дня рождения: обед или ужин в ресторане. Плюсы каждого варианта. Бизнес-ланч от 590 ₽. Скидка 20% именинникам.",
    "keywords": "день рождения обед или ужин петербург, когда лучше отметить день рождения, обед vs ужин ресторан",
    "date": "2026-06-25",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Обед или ужин? Этот вопрос звучит чаще, чем кажется. У каждого формата свои преимущества. Разбираем.",
    "sections": [
      {
        "heading": "Обед: дешевле, тише, быстрее",
        "body": "Плюсы обеда: дешевле (бизнес-ланч от 590 ₽), тише и спокойнее, дневной свет из окон (совсем другой вид), можно закончить рано и остаться вечер свободным. Минусы: нет живой музыки (только вечером), меньше праздничной атмосферы. Хорошо для: будничные дни, семьи с детьми, пожилые гости.",
        "list": [
          "Бизнес-ланч от 590 ₽ — очень экономично",
          "Тихо, дневной свет, спокойно",
          "Хорошо для семей с детьми",
          "Нет живой музыки"
        ]
      },
      {
        "heading": "Ужин: атмосфера, музыка, вечер",
        "body": "Плюсы ужина: живая музыка (чт–вс), вечерний вид на Петербург (особенный), более торжественная атмосфера, полноценный праздник. Минусы: дороже (~1 300 ₽/чел), более загружены выходные, требует бронирования заранее. Хорошо для: большинства дней рождения, когда хочется «по-настоящему».",
        "highlight": "Вечерний Петербург с 6-го этажа — это вид, ради которого стоит выбрать ужин. Огни города, закат (летом), живая музыка — это и есть праздник."
      },
      {
        "heading": "Вывод",
        "body": "Бюджет и простота — обед. Атмосфера и впечатление — ужин. Оба варианта возможны в «Парусах». Скидка 20% именинникам — в любое время. +7 (812) 991-10-90.",
        "list": [
          "Обед: бюджетно и спокойно",
          "Ужин: атмосферно и памятно",
          "Скидка 20% — в любое время",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-20-let-gde-otmetit-peterburg",
    "title": "День рождения 20 лет в Петербурге: первый взрослый юбилей",
    "metaTitle": "День рождения 20 лет в Петербурге | Паруса на крыше",
    "metaDescription": "Где отметить 20-летие в Санкт-Петербурге: ресторан с видом, живая музыка, атмосфера. Скидка 20% именинникам.",
    "keywords": "день рождения 20 лет петербург, двадцатилетие ресторан спб, где отметить 20 лет",
    "date": "2026-06-26",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "20 лет — это первый юбилей. Оглядываешься назад и понимаешь, что взрослая жизнь только начинается. Праздник должен соответствовать этому ощущению.",
    "sections": [
      {
        "heading": "20-летие: между студенчеством и взрослостью",
        "body": "В 20 лет хочется чего-то настоящего, но без помпезности. Стол у панорамного окна с видом на Петербург, живая музыка, авторская кухня — это то самое «настоящее». «Паруса на крыше» — ресторан, который одинаково хорош и для 20-летних и для 60-летних. Это редкость.",
        "list": [
          "Атмосфера без помпезности",
          "Вид на Петербург — лучший фон для фото",
          "Живая музыка — настоящая атмосфера",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Что важно для 20-летнего праздника",
        "body": "Красивые фото — важны. Вид с 6-го этажа — лучший фон в Петербурге. Живая музыка — настроение. Хорошая еда — конечно. Правильная компания — обязательно. Средний чек ~1 300 ₽/чел — посильно для молодёжного бюджета в разумных пределах.",
        "highlight": "20-летие в «Парусах» — это первый «взрослый» ресторан. Именно за этим первым опытом сюда приходят и потом возвращаются."
      },
      {
        "heading": "Бронирование",
        "body": "За 2–5 дней: +7 (812) 991-10-90. Стол у окна. Скидка 20% именинникам.",
        "list": [
          "За 2–5 дней",
          "+7 (812) 991-10-90",
          "Стол у окна по запросу",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать 20-летие", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "suprugi-den-rozhdeniya-romantika-spb",
    "title": "День рождения супруга в Петербурге: как устроить романтический вечер",
    "metaTitle": "День рождения супруга в Петербурге | Паруса на крыше",
    "metaDescription": "Как устроить романтический день рождения супругу или супруге в Санкт-Петербурге. Ресторан с видом, живая музыка. Скидка 20% именинникам.",
    "keywords": "день рождения супруга петербург, романтика день рождения жена муж спб, праздник для супруга",
    "date": "2026-06-26",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_sunset.webp",
    "lead": "День рождения супруга — это ваш шанс показать, что вы всё ещё замечаете его каждый день. Красивый ужин в «Парусах» — это любовь в конкретных действиях.",
    "sections": [
      {
        "heading": "Романтика через правильное место",
        "body": "Романтика не в цветах и стихах — она в деталях. Лучший стол у окна, который вы заказали заранее. Любимое вино, которое помнит официант. Шампанское при входе. Торт с надписью «С днём рождения» — и с именем, которое он слышит от вас каждый день. В «Парусах» все эти детали реализуемы.",
        "list": [
          "Лучший стол у окна — заранее",
          "Любимое вино — скажите какое",
          "Шампанское при входе — по запросу",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Что делает этот вечер незабываемым",
        "body": "Вечер с видом на Петербург в белую ночь или с огнями города в темноте. Живая музыка фоном. Хорошее вино. Ваши двое. Больше ничего не нужно. «Паруса» создают это пространство — вы его заполняете.",
        "highlight": "Ужин для супруга в «Парусах» — это напоминание, почему вы выбрали именно его. Хорошее место усиливает это ощущение."
      },
      {
        "heading": "Бронирование",
        "body": "За 2–4 дня: +7 (812) 991-10-90. Стол на двоих у окна. Скидка 20% именинникам.",
        "list": [
          "За 2–4 дня",
          "+7 (812) 991-10-90",
          "Стол на двоих у окна",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать для супруга", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "den-kollegi-kuda-poyti-spb",
    "title": "День рождения коллеги: куда пойти в Петербурге рабочей компанией",
    "metaTitle": "День рождения коллеги в Петербурге | Паруса на крыше",
    "metaDescription": "Куда пойти на день рождения коллеги в Санкт-Петербурге. Ресторан для рабочей компании с видом и хорошей кухней. Скидка 20% именинникам.",
    "keywords": "день рождения коллеги куда пойти петербург, рабочая компания ресторан спб, праздник с коллегами",
    "date": "2026-06-26",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "Рабочая компания на дне рождения коллеги — это не корпоратив. Это что-то между дружеским ужином и официальным мероприятием. Нужно место, которое работает для обоих состояний.",
    "sections": [
      {
        "heading": "Ресторан для рабочей компании",
        "body": "Коллеги за столом — это особый контекст. Нужно и поговорить о работе, и отвлечься от неё. Место должно создавать настроение «вечер», а не «продолжение рабочего дня». Панорама Петербурга с 6-го этажа помогает переключиться. Живая музыка добавляет нерабочую атмосферу.",
        "list": [
          "Переключение с рабочего на личное",
          "Хороший вид — тема для разговора",
          "Живая музыка — нерабочая атмосфера",
          "Скидка 20% имениннику-коллеге"
        ]
      },
      {
        "heading": "Формат для коллег",
        "body": "5–15 коллег, стол у окна или небольшой зал. À la carte или фиксированный набор блюд. Безналичный расчёт — уточните при бронировании. Праздник имениннику — приносит торт и поздравление.",
        "highlight": "День рождения коллеги в «Парусах» — это инвестиция в команду. Люди, которые отмечают вместе, работают лучше. Проверено."
      },
      {
        "heading": "Бронирование",
        "body": "За 3–5 дней для рабочей компании. Безналичный расчёт — уточните. Скидка 20% имениннику. +7 (812) 991-10-90.",
        "list": [
          "За 3–5 дней",
          "Безналичный расчёт по запросу",
          "Скидка 20% имениннику",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать для коллег", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "restoran-vid-kupolov-den-rozhdeniya",
    "title": "День рождения с видом на купола Петербурга: где найти",
    "metaTitle": "День рождения с видом на купола Петербурга | Паруса",
    "metaDescription": "Где отметить день рождения с видом на купола Санкт-Петербурга. «Паруса на крыше» — Казанский собор прямо перед вами. Скидка 20% именинникам.",
    "keywords": "день рождения вид купола петербург, ресторан вид казанский собор спб, праздник купола петербург",
    "date": "2026-06-26",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Купола петербургских соборов — один из самых узнаваемых видов в мире. Праздновать день рождения с этим видом — это особое ощущение.",
    "sections": [
      {
        "heading": "Вид на купола: почему это важно",
        "body": "С 6-го этажа «Парусов» видны купола Казанского и Никольского соборов. Это не просто красивый фон — это ощущение, что вы в центре настоящего Петербурга. Не открытка — живая картина, которая меняется с каждым часом.",
        "list": [
          "Купол Казанского собора — прямой обзор",
          "Никольский собор — в видимости",
          "Вид меняется: день, закат, ночь",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "День рождения на фоне истории",
        "body": "Казанский собор, построенный в 1811 году, всё ещё стоит перед вашим столом. Это ощущение масштаба и истории — то, что делает Петербург отличным от любого другого города. День рождения на этом фоне — что-то больше, чем просто ужин.",
        "highlight": "Вид на Казанский собор из «Парусов» — один из лучших в Петербурге. Архитектура 200-летней давности как декор для вашего праздника."
      },
      {
        "heading": "Бронирование",
        "body": "Просите стол у окна с видом на купола. За 3–5 дней: +7 (812) 991-10-90.",
        "list": [
          "Просите стол у окна с видом",
          "За 3–5 дней",
          "+7 (812) 991-10-90",
          "Скидка 20% именинникам"
        ]
      }
    ],
    "cta": { "text": "Забронировать с видом на купола", "href": "/den-rozhdeniya" }
  }
];
